exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-field-container{text-align:left}.select-field-container .label-wrapper label{color:#acacac !important}.bank-details-container{font-size:10px;color:#434175;min-height:70px}.bank-details-container .bank-details{display:flex;margin-bottom:1px}.bank-details-container .bank-details div:first-child{font-weight:900;width:50px}\n", ""]);

